module.exports = __webpack_public_path__ + "img/seasoning.9205878d.png";